import { Component, OnInit } from '@angular/core';
import { FooterService } from './footer.service';

@Component({
    selector: 'setup-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
    providers: [FooterService],
    standalone: false
})
export class FooterComponent implements OnInit {

  public footerData: string;
  constructor(private footerService: FooterService) { }

  ngOnInit() {
    this.footerService.getFooterData().subscribe(data => {
      this.footerData = data;
    });
  }

}
